import React from "react";
import {
  CursorIcon,
  LeadPencilIcon,
  SquareOutlineIcon,
  ImageAddIcon,
} from "../../SVGIcons";
import { EditorTool } from "../types/editorTypes";

interface ToolSelectionButtonsProps {
  currentTool: EditorTool;
  setCurrentTool: (tool: EditorTool) => void;
  onAddImageClick: () => void;
}

export const ToolSelectionButtons: React.FC<ToolSelectionButtonsProps> = ({
  currentTool,
  setCurrentTool,
  onAddImageClick,
}) => {
  return (
    <>
      {/* 選択ツール */}
      <button
        onClick={() => setCurrentTool('select')}
        className={`p-1.5 rounded flex items-center justify-center ${
          currentTool === 'select' ? 'bg-orange-500 text-white' : 'hover:bg-gray-100'
        }`}
        title="選択"
      >
        <CursorIcon className="w-5 h-5" />
      </button>

      {/* テキスト機能 */}
      <button
        onClick={() => setCurrentTool(currentTool === 'text' ? 'select' : 'text')}
        className={`p-1.5 rounded ${
          currentTool === 'text' ? 'bg-orange-500 text-white' : 'hover:bg-gray-100'
        }`}
        title="テキスト"
      >
        <span className="text-base font-bold w-5 h-5 flex items-center justify-center">T</span>
      </button>

      {/* マーカー */}
      <button
        onClick={() => setCurrentTool(currentTool === 'marker' ? 'select' : 'marker')}
        className={`p-1.5 rounded ${
          currentTool === 'marker' ? 'bg-orange-500 text-white' : 'hover:bg-gray-100'
        }`}
        title="マーカー"
      >
        <LeadPencilIcon className="w-5 h-5 fill-current !text-current" />
      </button>

      {/* 水平線 */}
      <button
        onClick={() => setCurrentTool(currentTool === 'horizontal' ? 'select' : 'horizontal')}
        className={`p-1.5 rounded ${
          currentTool === 'horizontal' ? 'bg-orange-500 text-white' : 'hover:bg-gray-100'
        }`}
        title="水平線"
      >
        <svg className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
          <rect x="2" y="9" width="16" height="2" rx="0.5" />
        </svg>
      </button>

      {/* 四角形 */}
      <button
        onClick={() => setCurrentTool(currentTool === 'rectangle' ? 'select' : 'rectangle')}
        className={`p-1.5 rounded ${
          currentTool === 'rectangle' ? 'bg-orange-500 text-white' : 'hover:bg-gray-100'
        }`}
        title="四角"
      >
        <SquareOutlineIcon className="w-5 h-5 stroke-current stroke-2" />
      </button>

      {/* 画像追加 */}
      <button
        onClick={onAddImageClick}
        className="p-1.5 rounded hover:bg-gray-100"
        title="画像を追加"
      >
        <ImageAddIcon className="w-5 h-5" />
      </button>
    </>
  );
};

export default ToolSelectionButtons;
